import CancelModalButton from 'components/Custom/CancelModalButton'
import SubmitModalButton from 'components/Custom/SubmitModalButton'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { setFormSubmitted } from 'store/Recruitment/actions'
import CreateJobInput from '../../CreateJob/CreateJobInput'
import { createApplicationNotes } from 'store/Recruitment/actions'
import { updateApplicationNote } from 'store/Recruitment/actions'

function CreateNoteModal({ showModal, setShowModal, note }) {
  const dispatch = useDispatch()
  const location = useLocation()

  const { jobApplication } = useSelector((store) => store.recruitment)

  const [description, setDescription] = useState('')

  useEffect(() => {
    if (note) setDescription(note?.description)
  }, [note])

  return (
    <Modal
      isOpen={showModal}
      toggle={() => setShowModal(false)}
      size='lg'
      centered
      scrollable
    >
      <ModalHeader className='border-bottom' toggle={() => setShowModal(false)}>
        {!note ? 'Create Note' : 'Edit Note'}
      </ModalHeader>
      <ModalBody className='scrollbar'>
        <form
          id='note'
          onSubmit={(e) => {
            e.preventDefault()

            dispatch(setFormSubmitted(true))

            const isValid = Boolean(description.trim())

            if (!isValid) return

            const payload = {
              application_id: location?.search?.split('=')?.at(1),
              description,
            }

            if (!note) {
              dispatch(createApplicationNotes(payload))
            } else {
              dispatch(
                updateApplicationNote(
                  note.id,
                  location?.search?.split('=')?.at(1),
                  payload
                )
              )
            }

            setShowModal(false)
          }}
        >
          <div className='d-flex flex-wrap w-100' style={{ gap: '0rem 1rem' }}>
            <CreateJobInput
              id='description'
              label='Description'
              placeholder='Enter Description'
              rows={3}
              required={true}
              fullSize={false}
              type='textarea'
              defaultValue={description}
              onChange={(val) => setDescription(val)}
            />
          </div>
        </form>
      </ModalBody>
      <ModalFooter>
        <CancelModalButton
          customFn={() => setShowModal(false)}
        ></CancelModalButton>
        <SubmitModalButton
          text={!note ? 'Create' : 'Update'}
          form='note'
        ></SubmitModalButton>
      </ModalFooter>
    </Modal>
  )
}

export default CreateNoteModal
